<template>
  <div class="container">
      <div class="container text-center mb-5">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">TABS PARA ORGANIZAR INFO</h1>
      </div>

      <nav>
        <div class="nav nav-movil nav-tabs" id="nav-tab" role="tablist">
            <a
                class="nav-link"
                @click="itemActive1 = true, itemActive2 = false, itemActive3 = false"
                :class="[
                  (!modoDark_var && itemActive1 && !itemActive2)? 'active' : '',
                  (modoDark_var && itemActive1 && !itemActive2)? 'DarkActive active' : '',
                  (modoDark_var && itemActive1==false && (itemActive2))? 'darkInactivo' : ''
                ]"
                id="nav-normContable-tab"
                data-toggle="tab"
                href="#nav-normContable"
                role="tab"
                aria-controls="nav-normContable"
                aria-selected="true"
                > <span class="verPc"><p class="m-0">Armonización Contable</p></span><span class="verMovil"><p class="m-0">Contable</p></span>
            </a>
            <a
                class="nav-link"
                @click="itemActive1 = false, itemActive2 = true, itemActive3 = false"
                :class="[
                  (!modoDark_var && itemActive2 && !itemActive1)? 'active' : '',
                  (modoDark_var && itemActive2 && !itemActive1)? 'DarkActive active' : '',
                  (modoDark_var && itemActive2==false && (itemActive1))? 'darkInactivo' : ''
                ]"
                id="nav-normFinanciera-tab"
                data-toggle="tab"
                href="#nav-normFinanciera"
                role="tab"
                aria-controls="nav-normFinanciera"
                aria-selected="false"
                >
                <span class="verPc"><p class="m-0">Ley de Disciplina Financiera</p></span><span class="verMovil"><p class="m-0">Financiera</p></span>
            </a>
            <a
              class="nav-link"
              @click="itemActive1 = false, itemActive2 = false, itemActive3 = true"
              :class="[
                  (!modoDark_var && itemActive3 && !itemActive1 && !itemActive2)? 'active' : '',
                  (modoDark_var && itemActive3 && !itemActive1 && !itemActive2)? 'DarkActive active' : '',
                  (modoDark_var && itemActive3==false && (itemActive1 || itemActive2))? 'darkInactivo' : ''
              ]"
              id="nav-contableFinanciera-tab"
              data-toggle="tab"
              href="#nav-contableFinanciera"
              role="tab"
              aria-controls="nav-contableFinanciera-tab"
              aria-selected="false"
              > <p class="m-0">Contable-Financiera</p>
          </a>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
          <div :class="[(itemActive1 && !itemActive2 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-normContable" role="tabpanel" aria-labelledby="nav-normContable-tab">

              <div class="card">
                  <div class="card-body">
                      <div class="row card-body">
                          <div class="container text-left mb-3">
                              <h6>Armonización Contable</h6>
                          </div>
                          SECCION 1 contenido tab 1 en card
                      </div>
                  </div>
              </div>
              <!-- componente aqui -->
              <h2>infomacion1</h2>
          </div>
          <div :class="[(itemActive2 && !itemActive1 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-normFinanciera" role="tabpanel" aria-labelledby="nav-normFinanciera-tab">
            <div class="card">
              <div class="card-body">
                <div class="row card-body">
                  <div class="container text-left mb-3">
                      <h6>Información de la Ley de Disciplina Financiera</h6>
                  </div>
                    otra seccion contenido tab 2 en card
                </div>
              </div>
            </div>
            <!-- aqui puede estar tu componente, o tu info -->
            <h2>infomacion2</h2>
          </div>
          <div :class="[(itemActive3 && !itemActive1 && !itemActive2)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-contableFinanciera" role="tabpanel" aria-labelledby="nav-contableFinanciera-tab">
          <div class="card">
              <div class="card-body">
                  <div class="row card-body">
                    <div class="container text-left mb-3">
                      <h6>Información contable-Financiera</h6>
                  </div>
                    otra seccion contenido tab 3 en card
                  </div>
              </div>
          </div>
            <h2>infomacion3</h2>
        </div>
      </div>


  </div>
</template>
<script>
import { mapState } from "vuex";
import('@/assets/css/tab.css');

export default ({
  name: 'Tab',
  computed:{ ...mapState(['modoDark_var']) },
  data() {
    return{
      itemActive1: true,
      itemActive2: false,
      itemActive3: false,
    }
  },
})
</script>
